
import Vue from 'vue'

export const GlobalEventBus = new Vue({
  methods: {
    testEvent() {
      alert('GlobalEventBus has fired a test event')
    }
  }
})
